<template>
  <!-- 国际退换货-销售发起申请组件 -->
  <div>
    <InterReturnExchangeSalesTableList />
  </div>
</template>
<script type="es6">
import InterReturnExchangeSalesTableList from './InterReturnExchangeSalesTableList.vue';
export default {
  data () {
    return {

    };
  },
  components: {
    InterReturnExchangeSalesTableList
  },
  methods: {

  }
};
</script>
